import styled from 'styled-components';

export const CommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
`;
export const CommentTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const CommentTitleText = styled.div`
  font-size: 14px;
  color: var(--secondary-color);
  margin-bottom: 4px;
`;

export const CommentText = styled.div`
  color: var(--base-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 17.9px;
  text-align: left;
`;
